module.exports = __webpack_public_path__ + "static/media/ruler.0d896373.svg";